import React from 'react'
import '../styles/pageStyles/Browse.scss'
import BrowseContent from '../components/Browse/BrowseContent'
import Suggestions from '../components/Browse/Suggestions'

const Browse = () => {
    return (
        <div className='browse'>
            <BrowseContent />
            <Suggestions />
        </div>
    )
}

export default Browse